import React from 'react'

import * as s from './accordion.styles'

interface Props {
    className?: string
    children: React.ReactNode
}

const Accordion = ({children, className}: Props) => (
    <s.Wrapper className={className}>{children}</s.Wrapper>
)

export default Accordion
